// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-label {
    -ms-flex-align: start;
        align-items: flex-start;
}

    .csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-label span {
        font-weight: 700;
    }

.csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-requiredLabel {
    -ms-flex-align: start;
        align-items: flex-start;
}

.csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-requiredLabel span {
        font-weight: 700;
    }

.csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-requiredLabel .MuiFormControlLabel-asterisk {
        display: inline-block;
        color: #ff0000;
    }

.csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-sublabel {
    -ms-flex-pack: justify;
        justify-content: space-between;
    margin-left: 10px;
}

.csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-axisContainer {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: end;
        align-items: flex-end;
}

.csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-axisLabel {
    margin-right: 20px;
}

.csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-axisTextField {
    margin: 0px 10px 0px 3px;
    width: 40px;
    display: inline-block;
}

.csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-axisTextField .TextFieldinput {
    display: -ms-flexbox;
    display: flex;
}`, "",{"version":3,"sources":["webpack://./src/csi/threeD/cameraPositions3D/NewCameraPositionDialog.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAuB;QAAvB,uBAAuB;AAK3B;;IAHI;QACI,gBAAgB;IACpB;;AAGJ;IACI,qBAAuB;QAAvB,uBAAuB;AAS3B;;AAPI;QACI,gBAAgB;IACpB;;AACA;QACI,qBAAqB;QACrB,cAAc;IAClB;;AAGJ;IACI,sBAA8B;QAA9B,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,oBAAa;IAAb,aAAa;IACb,mBAAqB;QAArB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,oBAAa;IAAb,aAAa;AACjB","sourcesContent":[".label {\n    align-items: flex-start;\n\n    span {\n        font-weight: 700;\n    }\n}\n\n.requiredLabel {\n    align-items: flex-start;\n\n    span {\n        font-weight: 700;\n    }\n    :global(.MuiFormControlLabel-asterisk) {\n        display: inline-block;\n        color: #ff0000;\n    }\n}\n\n.sublabel {\n    justify-content: space-between;\n    margin-left: 10px;\n}\n\n.axisContainer {\n    display: flex;\n    align-items: flex-end;\n}\n\n.axisLabel {\n    margin-right: 20px;\n}\n\n.axisTextField {\n    margin: 0px 10px 0px 3px;\n    width: 40px;\n    display: inline-block;\n}\n\n.axisTextField :global(.TextFieldinput) {\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-label`,
	"requiredLabel": `csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-requiredLabel`,
	"sublabel": `csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-sublabel`,
	"axisContainer": `csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-axisContainer`,
	"axisLabel": `csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-axisLabel`,
	"axisTextField": `csi-threeD-cameraPositions3D-NewCameraPositionDialog-module-axisTextField`
};
module.exports = ___CSS_LOADER_EXPORT___;
